import { useEffect, useState } from "react";
import logo from "../assets/logo.png";
const Preloader = () => {
  const [spin, setSpin] = useState(true);
  useEffect(() => {
    setTimeout(() => {
      setSpin(false);
    }, 2000);
  });
  return (
    <>
      {spin ? (
        <div className="  h-[100vh] w-[100vw] flex align-middle justify-center items-center ">
          <img src={logo} alt="spinner" className=" h-auto" />
        </div>
      ) : (
        ""
      )}
    </>
  );
};

export default Preloader;
